import { createBrowserRouter, type RouteObject } from "react-router-dom";

/**
 * vite-react-ssg gives every prerendered route a client loader that fetches
 * static-loader-data-manifest-<build hash>.json, then the page's data file,
 * and calls .json() on whatever comes back. A tab opened before a deploy
 * still asks for the old hash; those files are gone, the assets'
 * single-page-application fallback answers with index.html, and the next
 * in-app navigation dies on "Unexpected token '<'" until a refresh.
 *
 * No route here defines a loader, so that data is always null. Dropping the
 * injected loaders removes the fetches and the failure with them.
 */
export function withoutLoaders(routes: RouteObject[]): RouteObject[] {
  return routes.map(({ loader: _loader, children, ...route }) =>
    (children ? { ...route, children: withoutLoaders(children) } : route) as RouteObject,
  );
}

export const createRouter: typeof createBrowserRouter = (routes, opts) =>
  createBrowserRouter(withoutLoaders(routes), opts);
